// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3DXaf","disabled":"FileBtn_disabled__MPqmP","warn":"FileBtn_warn__3K3GC","fade":"FileBtn_fade__YYIt7"};